export default __webpack_public_path__ + "static/challengeImageBanner-d361b3467f66bd05ff6d9a13836a950f.jpg";